
import { z } from "zod";

export const PreferredContactMethodValues = ["CALL", "EMAIL", "TEXT"] as const;
export const PreferredContactMethodSchema = z.enum(PreferredContactMethodValues);
export const PreferredContactMethod = PreferredContactMethodSchema.enum;
export type PreferredContactMethod = (typeof PreferredContactMethodValues)[number];
export const PreferredContactMethodDisplayNames = { "CALL": "Call",
"EMAIL": "Email",
"TEXT": "Text", } satisfies Record<PreferredContactMethod, string>;
